// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"PageFooter_footerContainer__3SgTV","webviewFooter":"PageFooter_webviewFooter__2oCnn"};